<template>
    <div class="table-container">
        <table class="table is-striped is-narrow">
            <tr><th>ID</th><th>Year</th><th>Event</th></tr>
            <tr><td>A</td><td>2004</td><td>MMR: What they didn't tell you, Dispatches</td></tr>
            <tr><td>B</td><td>2004</td><td>Untouchables, written by Michael Gillard and Laurie Flynn</td></tr>
            <tr><td>C</td><td>2004</td><td>Terror Sting, Mazher Mahmood, News of the World</td></tr>
            <tr><td>D</td><td>2006</td><td>Extraordinary Rendition, Stephen Grey</td></tr>
            <tr><td>E</td><td>2006</td><td>Panorama Undercover: Football's Dirty Secrets</td></tr>
            <tr><td>F</td><td>2007</td><td>Dispatches, Undercover Mosque</td></tr>
            <tr><td>G</td><td>2008</td><td>Panorama, What happened to Baby P?</td></tr>
            <tr><td>H</td><td>2009</td><td>Daily Telegraph, The Expenses File (MPs expenses)</td></tr>
            <tr><td>I</td><td>2009</td><td>Dispatches, Inside Britain's Israel Lobby (Peter Oborne)</td></tr>
            <tr><td>J</td><td>2010</td><td>David Leigh and Rob Evan (Guardian), Corruption at BAE Systems</td></tr>
        </table>
    </div>

</template>

<script>
    export default {
        name: "AppKey"
    }
</script>

<style scoped>

</style>